<template>
    <ProLink
        :to="{
            name: 'handbook-product-all',
            params: { product: currentProduct.slug, pathMatch: `${page.path}` },
            query: { section: page.section },
        }"
        class="handbook-search-result"
        :aria-label="`${page.breadcrumb ? `${page.breadcrumb} –  ` : ''}${page.title}`"
    >
        <div aria-hidden="true">
            <div v-if="page.breadcrumb" class="handbook-search-result__breadcrumbs">
                <span v-for="crumb in page.breadcrumb">
                    {{ crumb }}
                    <ProIcon icon="arrow-right" />
                </span>
            </div>
            <span aria-hidden="true" class="handbook-search-result__title text-heading text-heading--sm">
                {{ page.title }}
            </span>
        </div>
        <ProIcon class="handbook-search-result__arrow" icon="arrow-right" />
    </ProLink>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        page: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters({
            currentProduct: "handbook/getCurrentProduct",
        }),
    },
};
</script>
